<template>
  <div>
    <div v-if="!user.property">
      <div class="alert alert-warning">
        <span>سوف تتمكن من إضافة طلب بعد ربط حسابك مع عقار محدد.</span>
      </div>
    </div>
    <div v-else>
      <div class="text-right">
          <button class="btn btn-primary btn-sm" @click="addMaintenanceTap">
              <fa icon="plus" class="ml-2" />
              <span>إضافة طلب</span>
          </button>
      </div>
    <PanelList
      class="mt-3"
      :items="maintenances"
      title="الطلبات"
      :isAllSelected="isAllSelected"
      @toggle-items-selection="toggleMaintenancesSelection()"
      @delete-selected="deleteSelectedMaintenances()"
    >
      <MaintenancePanelItem
        v-for="(maintenance, i) in maintenances"
        :key="i"
        :maintenance="maintenance"
      />
    </PanelList>

    <MaintenanceModal />
  </div>
  </div>
</template>

<script>
import PanelList from "@/components/general/panel-list";
import MaintenancePanelItem from "@/components/panel-items/maintenance";
import MaintenanceModal from "@/components/modals/maintenance";
import MaintenancesMixin from '@/mixins/maintenances'
import PropertiesMixin from '@/mixins/properties'
import AuthMixin from '@/mixins/auth'

export default {
  mixins: [MaintenancesMixin, PropertiesMixin, AuthMixin],

  methods: {
    addMaintenanceTap () {
      this.selectMaintenance(null)
      this.selectProperty(null)
      this.$bvModal.show('maintenance-modal')
    },
  },

  computed: {
    isAllSelected () {
      return this.maintenances.length == this.selectedMaintenances.length
    }
  },

  components: {
    PanelList,
    MaintenancePanelItem,
    MaintenanceModal,
  },
};
</script>